import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mailing" }
const _hoisted_2 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "Client email", -1)
const _hoisted_4 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "Client company", -1)
const _hoisted_6 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "Client first name", -1)
const _hoisted_8 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "Language", -1)
const _hoisted_10 = { class: "p-field-radiobutton" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", null, "Polish", -1)
const _hoisted_12 = { class: "p-field-radiobutton" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", null, "English", -1)
const _hoisted_14 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", null, "Sales Person", -1)
const _hoisted_16 = { class: "p-field-radiobutton" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "Bartosz", -1)
const _hoisted_18 = { class: "p-field-radiobutton" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", null, "Paula", -1)
const _hoisted_20 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "Email type", -1)
const _hoisted_22 = { class: "p-field-radiobutton" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", null, "General", -1)
const _hoisted_24 = { class: "p-field-radiobutton" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", null, "Person responsible", -1)
const _hoisted_26 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", null, "Personalized sentence", -1)
const _hoisted_28 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", null, "Subject", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_MailingPreview = _resolveComponent("MailingPreview")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Input, {
        type: "email",
        modelValue: _ctx.email,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_Input, {
        type: "text",
        modelValue: _ctx.clientCompany,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.clientCompany = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_Input, {
        type: "text",
        modelValue: _ctx.clientName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.clientName = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_RadioButton, {
          name: "language",
          value: "pl",
          modelValue: _ctx.language,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.language = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_RadioButton, {
          name: "language",
          value: "en",
          modelValue: _ctx.language,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.language = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_13
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_RadioButton, {
          name: "salesPerson",
          value: "Bartosz",
          modelValue: _ctx.salesPerson,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.salesPerson = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_17
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_RadioButton, {
          name: "salesPerson",
          value: "Paula",
          modelValue: _ctx.salesPerson,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.salesPerson = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_19
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _hoisted_21,
      _createVNode("div", _hoisted_22, [
        _createVNode(_component_RadioButton, {
          name: "type",
          value: "general",
          modelValue: _ctx.type,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.type = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_23
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode(_component_RadioButton, {
          name: "type",
          value: "person",
          modelValue: _ctx.type,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.type = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_25
      ])
    ]),
    _createVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode(_component_Input, {
        type: "text",
        modelValue: _ctx.personalizedSentence,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.personalizedSentence = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_28, [
      _hoisted_29,
      _createVNode("div", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subjects, (item) => {
          return (_openBlock(), _createBlock("div", {
            key: item,
            class: "p-field-radiobutton"
          }, [
            _createVNode(_component_RadioButton, {
              name: "subject",
              value: item,
              modelValue: _ctx.subject,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.subject = $event))
            }, null, 8, ["value", "modelValue"]),
            _createVNode("label", null, _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_MailingPreview, {
      email: _ctx.email,
      "client-name": _ctx.clientName,
      language: _ctx.language,
      "sales-person": _ctx.salesPerson,
      type: _ctx.type,
      "personalized-sentence": _ctx.personalizedSentence,
      subject: _ctx.subject,
      "video-link": _ctx.videoLink,
      website: _ctx.website,
      verb: _ctx.verb,
      "client-company": _ctx.clientCompany,
      "sales-person-job": _ctx.salesPersonJob,
      "sales-person-full": _ctx.salesPersonFull,
      "sales-person-title": _ctx.salesPersonTitle,
      onSend: _ctx.sendEmail
    }, null, 8, ["email", "client-name", "language", "sales-person", "type", "personalized-sentence", "subject", "video-link", "website", "verb", "client-company", "sales-person-job", "sales-person-full", "sales-person-title", "onSend"])
  ]))
}